import { Button, Modal, Space } from "antd";

import { selectFilters } from "../../../businesses/businessesSlice";
import { IBusinessFullQuery } from "../../../../interfaces/businessFull.interface";
import { DownloadOutlined, SendOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

import { getBusinessesMap } from "../../../businesses/businessesApi";
import Loader from "../../../common/loader/Loader";

export default function BusinessesMap() {
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [mapUrl, setMapUrl] = useState("");
  const [visible, setVisible] = useState(false);
  const getMap = async (params: { salesRepresentative?: string }) => {
    setIsLoadingMap(true);
    try {
      const result = await getBusinessesMap({});
      if (result.url) setMapUrl(result.url);
    } catch (error) {
    } finally {
      setIsLoadingMap(false);
    }
  };

  useEffect(() => {
    getMap({});
  }, []);

  const handleDownloadMap = async () => {
    try {
    } catch (error) {
      console.log("error", error);
    } finally {
    }
  };
  const handleOk = () => {
    setIsLoadingMap(true);
    setTimeout(() => {
      setIsLoadingMap(false);
      setVisible(false);
    }, 3000);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  return (
    <div>
      <Button
        icon={
          <img
            height={40}
            width={40}
            src="https://lemonpay-design-templates.s3.eu-central-1.amazonaws.com/google-maps.svg"
          ></img>
        }
        type="text"
        onClick={() => {
          setVisible(true);
        }}
      ></Button>
      <Modal
        bodyStyle={{ padding: "0", height: "70vh" }}
        visible={visible}
        title={
          <Space align="center">
            <div>Business Map</div>
            <Button
              style={{ flex: "auto" }}
              type="link"
              href={mapUrl}
              target="_blank"
              icon={<SendOutlined />}
            >
              {" "}
              Share
            </Button>
          </Space>
        }
        onOk={handleCancel}
        okText="Close"
        onCancel={handleCancel}
        footer={null}
        width={500}
      >
        {isLoadingMap && <Loader text="Loading Locations..." />}

        {!isLoadingMap && mapUrl && (
          <iframe
            src={mapUrl}
            width="100%"
            height="98%"
            //@ts-ignore
            style={{ border: "none", margin: 0, padding: 0 }}
            scrolling="no"
          ></iframe>
        )}
      </Modal>
    </div>
  );
}
